import request from '@/utils/request'

//获取卸载记录列表
export function getUninstallRecordList(params) {
    return request.get('/api-device/device/uninstall-log/list', params)
}
